import WRAP from "WRAP-JS";
import LegendNavaids from "../legend/LegendNavaids";
import {
  configNavaidsDh,
  configNavaidsLayer
} from "./config/ConfigNavaids";
import { MAP_ID_NAVAIDS } from "../../../store/MapContentsState";
import { getCycleDate } from "../../../Authorization";
import { COMMUNICATE_ERROR_MESSAGE_NAVAIDS, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD } from "../../../constants/ErrorMessage";

class Navaids {
  static NAME = MAP_ID_NAVAIDS;
  static VOR_NAME = Navaids.makeContentsKey('VOR');
  static VOR_DME_NAME = Navaids.makeContentsKey('VORDME');
  static VOR_TAC_NAME = Navaids.makeContentsKey('VORTAC');
  static TACAN_NAME = Navaids.makeContentsKey('TACAN');
  static NDB_NAME = Navaids.makeContentsKey('NDB');
  static CONTENTS_VISIBLE_STATE_DEFAULT = {
    [Navaids.VOR_NAME]: true,
    [Navaids.VOR_DME_NAME]: true,
    [Navaids.VOR_TAC_NAME]: true,
    [Navaids.TACAN_NAME]: true,
    [Navaids.NDB_NAME]: true,
  };

  contentsVisibleState = {...Navaids.CONTENTS_VISIBLE_STATE_DEFAULT};

  tileIndex;
  dhNavaids;
  layerNavaids;
  visible;
  ready = false;
  contentsDispatcher

  constructor() {
    this.layerNavaids = new WRAP.Geo.Layer(Navaids.NAME);
    this.layerNavaids.setVisible(false);
  }

  async initialize() {
    await this.initData();
    this.initLayer();
    this.ready = true;
  }

  initData() {
    this.dhNavaids = new WRAP.Data(configNavaidsDh);
    return new Promise((resolve) => {
      this.dhNavaids.updated('index', ref => {
        if (ref && Array.isArray(ref)) {
          const cycleDate = getCycleDate();
          const target = ref.find(data => data.Cycledate === cycleDate);
          this.tileIndex = target?.Prefix;
        }
        if (this.tileIndex) {
          resolve();
        }
      }, () => {
        this.contentsDispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_NAVAIDS,
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD
        }});
      });
    });
  }

  initLayer() {
    this.layerNavaids.configure(this.dhNavaids, configNavaidsLayer);
    this.layerNavaids.set({
      index: this.tileIndex
    });

    this.layerNavaids.setTooltip(geo => {
      return `${geo.properties.ident} / ${geo.properties.name}`;
    });

    this.layerNavaids.setAttributes({
      filter: this._visibleFilter.bind(this)
    });
  }

  async drawLayer(visible) {
    this.visible = visible;
    if (!this.dhNavaids) {
      await this.initialize();
    }
    this.setVisible(this.visible);
  }

  getLayer() {
    return [this.layerNavaids];
  }

  setVisible(visible, contents) {

    if (contents) {
      this.contentsVisibleState[contents] = visible;
      this.layerNavaids.invalidate();
    } else {
      if(visible) {
        this.layerNavaids.show();
      } else {
        this.layerNavaids.hide();
      }
    }
  }

  getLegend() {
    return {
      id: Navaids.NAME,
      label: 'Navaids',
      component: LegendNavaids,
      contents: this
    };
  }

  getContentsVisibleState() {
    return this.contentsVisibleState;
  }

  resetContentsVisibleState() {
    this.contentsVisibleState = {...Navaids.CONTENTS_VISIBLE_STATE_DEFAULT};
  }

  _visibleFilter(feature) {
    return this.contentsVisibleState[ Navaids.makeContentsKey(feature.properties.kind) ];
  }

  static makeContentsKey(kind) {
    return `${Navaids.NAME}_${kind}`;
  }

  setContentsDispatcher(dispatcher) {
    this.contentsDispatcher = dispatcher;
  }
}

export default Navaids;